<template>
  <div v-if="view !== 'compartido'">
    <div style="text-align: right;margin-bottom: 5px;">
      <span>
        Viendo documentos que ingresaron
      </span>
      <span v-if="rangeSelected.valor !== 'personalizado'">
        {{ rangeSelected.nombre }}
      </span>
      <span v-if="rangeSelected.valor === 'personalizado'">
        entre el
        <!--<input type="date" class="fecha" v-model="periodoDesde">-->
        <datetime
          v-model="rangeFrom"
          input-class="input-date"
          :phrases="{ok: 'Seleccionar',
           cancel: 'Cancelar'}"
          value-zone="local"
          format="yyyy-MM-dd"
          data-cy="start-time"
        />
        y el
        <datetime
          v-model="rangeUntil"
          input-class="input-date"
          :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
          value-zone="local"
          format="yyyy-MM-dd"
          data-cy="end-time"
        />
        <span>
          <vs-button
            radius
            class="ml-3 d-inline"
            color="primary"
            type="border"
            icon="search"
            size="small"
            @click="changeFilters(currentFilters)"
            data-cy="filter-by-date"
          />
        </span>
      </span>
      <vs-dropdown vs-trigger-click
        style="margin-left: 15px"
        data-cy="change-date">
        <a class="a-icon" href="#">
          Cambiar
          <vs-icon class="" icon="expand_more"></vs-icon>
        </a>
        <vs-dropdown-menu>
          <vs-dropdown-item
            style="width:200px"
            v-for="range in ranges"
            :key="range.valor"
            v-on:click.native="selectRange(range)"
            data-cy="change-date-item"
          >
            {{ range.nombre }}
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <!--<filtros
      :dntType="'files'"
      :users="usersCompany"
      :groups="groupsCompany"
      :documents="documentTypesState.list"
      :institutions="institutionTypesState.list"
      :configuracion-vista="configuration"
      :periodos="ranges"
      :has-query-filters="!!queryFilters"
      :clear-query-filters="clear"
      v-on:filtros-aplicados="changeFilters"
    />-->
    <filtros-letty
      :filtersView="filterView"
      :users="usersCompany"
      :groups="groupsCompany"
      :documents="allDocumentsState.list"
      :institutions="institutionTypesState.list"
      :institutionsDD="institutionsDocDigitalState.list"
      :periodos="ranges"
      :has-query-filters="!!queryFilters"
      :clear-query-filters="clear"
      v-on:filtros-aplicados="changeFilters"
    />
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import FiltrosLetty from '@/febos/global/_vue/componentes/FiltrosLetty';
import ConfigFileFiltersMixin from '@/febos/global/_vue/componentes/filtersLetty/ConfigFileFiltersMixin';
import FiltersDntMixin from '@/febos/chile/dnt/mixins/FiltersDntMixin';
import FindTypeDocumentMixin from '@/febos/chile/dnt/mixins/FindTypeDocumentMixin';
import { getShareableFilters } from '@/febos/chile/dnt/utils/fitlers';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import { DATE_RANGE_LAST_6_MONTH, DATE_RANGES } from '@/febos/chile/commons/dateCommons';
import SelectorDateMixin from '@/febos/global/_vue/componentes/filtersLetty/SelectorDateMixin';
import { institutionsDocDigitalState } from '@/febos/chile/lists/store/moduloListGetters';

export default {
  components: { FiltrosLetty },
  props: ['value', 'onChange', 'clear', 'defaultDate'],
  mixins: [FiltersDntMixin, FindTypeDocumentMixin, ConfigFileFiltersMixin, SelectorDateMixin],
  data() {
    const { view } = this.$route.params;
    const range = this.defaultDate ? this.defaultDate : DATE_RANGE_LAST_6_MONTH;
    return {
      ranges: DATE_RANGES,
      rangeSelected: range,
      rangeFrom: '',
      rangeUntil: '',
      view,
      currentFilters: '',
      queryFilters: this.$route.query.filters
    };
  },
  watch: {
    'empresa.id'(newId, oldId) {
      if (newId && newId !== oldId) {
        this.loadCompanyData();
      }
    }
  },
  created() {
    this.selectRange(this.rangeSelected, true);
    if (this.view !== 'compartido') {
      this.loadCompanyData();
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'usersCompany',
      'groupsCompany'
    ]),
    ...mapGetters('List', [
      'allDocumentsState',
      'institutionTypesState',
      'institutionsDocDigitalState'
    ]),
    configuration() {
      return this.getFilterViewLetty(this.view, this.company.iut);
    },
    filterView() {
      return this.getFilterViewLetty(this.view, this.company.iut);
    }
  },
  methods: {
    ...mapActions('Empresas', [
      'getUsersCompany',
      'getGroupsCompany'
    ]),
    ...mapActions('List', [
      'fetchAllDocuments',
      'fetchInstitutionTypes',
      'fetchInstitutionsDocDigital'
    ]),
    loadCompanyData() {
      this.getUsersCompany({
        empresaId: this.empresa.id,
        pagina: 1,
        filas: 10000,
        // buscarInfoExtra: 'si',
        // filtroInfoExtra: 'CARGO'
      });
      this.getGroupsCompany({ empresaId: this.empresa.id });
      this.fetchAllDocuments();
      this.fetchInstitutionTypes();
      this.fetchInstitutionsDocDigital();
    },
    async changeFilters(filters, onMounted) {
      const rangeFrom = this.$moment(this.rangeFrom).format('YYYY-MM-DD');
      const rangeUntil = this.$moment(this.rangeUntil).format('YYYY-MM-DD');
      const defaultFilters = `fechaCreacion:${rangeFrom}--${rangeUntil}`;
      this.currentFilters = filters;
      const newFilters = filters !== ''
        ? `${defaultFilters}|${filters}`
        : defaultFilters;

      if (!onMounted) {
        const nonShareableFilters = [
          ...['destinoVisorIds', 'destinoParticipanteIds', 'destinoResponsableIds'],
          // TODO: agregar campo de busqueda de coincidencias
          ...(this.configuration.filtrosFijos || []).map((filterConfig) => filterConfig.campo)
        ];
        const queryFilters = getShareableFilters(newFilters, nonShareableFilters);
        updateSearchParams({ filters: queryFilters });
      }
      this.onChange(newFilters, onMounted);
    },
    clearQueryFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      this.$router.go();
    }
  }
};

</script>
<style>
.input-date {
  border: 1px solid #bcbcbc;
  padding: 6px 8px;
  border-radius: 5px;
}
.search-bar {
  align-items: baseline;
  width: 50%;
}
</style>
